import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IDadataAddressResponse,
  IDadataCountryResponse,
  IDadataCurrencyResponse,
  IDadataSuggestAddressRequest,
} from 'cloud-shared-lib';
import { ApiLinks } from '@cutting/app.api-links';

@Injectable({ providedIn: 'root' })
export class DadataService {
  constructor(private http: HttpClient) {}

  getCountry(value: string, count = 5): Observable<IDadataCountryResponse[]> {
    const params = new HttpParams().set('value', value).set('count', count);

    return this.http.get<IDadataCountryResponse[]>(ApiLinks.dadata + '/country', { params: params });
  }

  getCurrency(value: string, count = 5): Observable<IDadataCurrencyResponse[]> {
    const params = new HttpParams().set('value', value).set('count', count);

    return this.http.get<IDadataCurrencyResponse[]>(ApiLinks.dadata + '/currency', { params: params });
  }

  gatAddress(request: IDadataSuggestAddressRequest): Observable<IDadataAddressResponse[]> {
    return this.http.post<IDadataAddressResponse[]>(ApiLinks.dadata + '/address', request);
  }
}
